import React from 'react';

export default function ThemeToggle() {
  // Empty component as we're removing the theme toggle functionality
  return null;
}